//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OddsTable from '../components/OddsTable'

export default {
    name: 'OddEven',
    components: {
        OddsTable
    }
}
